// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Kcy1v","right":"Footer_right__TkIZy","buttons":"Footer_buttons__sBd-K"};